export default __webpack_public_path__ + "static/nick-bitmoji-e3bc2ca4b06611d78fafcd4b364a1768.png";